export const SCROLL_TO_OPTIONS = {
  duration: 1000,
  offset: -16,
  dataAttr: 'data-page-is-scrolling',
}
